import range from 'lodash/range';

import {SidenavSection, SidenavSectionItem} from 'common/components/sidenav/types';

const commonFields = {
  userName: `Harry Potter`,
};

function createRandomItem(): SidenavSectionItem {
  return {
    label: Math.random().toString(),
    value: Math.random().toString(),
    ...commonFields,
  };
}

export const sidenavSections: SidenavSection[] = [
  {
    label: `Section 1`,
    items: [
      {
        label: `no user`,
        value: `nouser`,
      },
      {
        label: `link`,
        value: `link`,
        href: `https://google.com`,
        target: `_blank`,
      },
      {
        label: `Active Item`,
        value: `active`,
      },
      {
        label: `Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium.`,
        value: `long`,
      },
      {
        label: `item with overflow menu`,
        value: `long`,
        overflowMenuSections: [
          {
            items: [
              {
                label: `Favorite`,
                icon: `star-top-events`,
              },
              {
                label: `Rename`,
                icon: `edit`,
              },
            ],
          },
        ],
      },
      ...range(10).map(createRandomItem),
    ],
    isCollapsible: true,
  },
  {
    label: `Section 2`,
    items: range(10).map(createRandomItem),
    isCollapsible: true,
  },
  {
    label: `Empty Section`,
    items: [],
    emptyNotice: `Looks like there's nothing here`,
    isCollapsible: true,
  },
];
